<template>
  <div class="flex">
    <el-dropdown class="user" trigger="click" @command="handleCommandUser" v-if="isLogin">
      <span class="flex">
        <div>
          <img
            :src="userAvatar"
            alt=""
            class="user-avatar"
            v-if="userAvatar.includes('/person.avatar') && !userAvatar.includes('auth0')"
          />
          <img src="@/assets/images/avatar-moren.png" class="user-avatar" alt="" v-else />
        </div>
        <span class="user-name">{{ displayName }}</span>
      </span>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <el-dropdown-item command="info">{{ $t('my_account') }}</el-dropdown-item>
        <el-dropdown-item command="wallet" v-if="isFree">{{ $t('my_wallet') }}</el-dropdown-item>
        <el-dropdown-item v-if="false">{{ $t('statistics_center') }}</el-dropdown-item>
        <el-dropdown-item command="history">{{ $t('learn_history') }}</el-dropdown-item>
        <el-dropdown-item command="correct" v-if="isAllowMarked">{{
          $t('mark_correct_person')
        }}</el-dropdown-item>
        <el-dropdown-item command="credits" v-if="isAdminOrEditor">
          <div class="flex">
            <span>{{ $t('manage') }}</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="logout">{{ $t('logout') }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <span v-else class="clickable no-login" @click="clickLogin">{{ $t('login_signup') }}</span>
  </div>
</template>

<script>
import analytics from '@/utils/AnalyticsCenter'
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState({
      role: (state) => state.user.role,
    }),
    ...mapGetters('user', {
      displayName: 'displayName',
    }),
    // 头像
    userAvatar() {
      return this.$store.state.user.picture || ''
    },
    // 用户名
    userName() {
      return (
        `${this.$store.state.user.given_name} ${this.$store.state.user.family_name}` ||
        this.$store.state.user.nickname ||
        ''
      )
    },
    // 是否登录
    isLogin() {
      return this.$store.state.user.login
    },
    isAdminOrEditor() {
      if (this.$store.state.user.role === 'editor' || this.$store.state.user.role === 'admin') {
        return true
      } else {
        return false
      }
    },
    // 是否允许批改
    isAllowMarked() {
      return ['admin', 'writer'].includes(this.role)
    },
    isFree() {
      return this.$store.state.user.isFree
    },
  },
  methods: {
    handleCommandUser(command) {
      switch (command) {
        case 'info':
          this.$router.push('/personal-center/index/personal-info')
          break
        case 'wallet':
          this.$router.push('/personal-center/index/mywallet/recharge')
          break
        case 'history':
          this.$router.push('/personal-center/index/learn-history')
          break
        case 'correct':
          this.$router.push('/personal-center/manual-correction')
          break
        case 'credits':
          this.$router.push('/personal-center/index/management')
          break
        case 'logout': {
          this.$store.dispatch('user/handleLogout', { reLogin: false })
          break
        }
        default:
          break
      }
    },
    clickLogin() {
      //hskweb_sign_click埋点
      analytics.logEvent('hskweb_sign_click')
      this.$store.dispatch('user/handleLogout', { reLogin: true })
    },
  },
}
</script>

<style lang="scss" scoped>
.user-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.user-name {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  color: #ffffff;
  max-width: 100px;
  overflow: hidden;
  margin-left: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.no-login {
  color: #ffffff;
}
</style>
